import React from 'react';
import { Link } from 'react-router-dom';

/**
 * InlineLink — subtle, editorial-style inline anchor used inside body copy
 * on vertical spoke pages.
 *
 * Rendering choice is derived automatically from `href`:
 *   - http(s) → external <a target="_blank">
 *   - contains "#"      → plain <a> (hash navigation, cross-page or same-page)
 *   - otherwise         → react-router <Link>
 *
 * Styling: body-text-colored, subtle underline offset. Underline saturates
 * to `primary` on hover — quiet in copy, clearly interactive on approach.
 */
export default function InlineLink({ href, children, testId, className = '', ...rest }) {
  const base =
    'text-foreground underline decoration-muted-foreground/40 decoration-1 underline-offset-[3px] ' +
    'hover:decoration-primary hover:text-primary transition-colors';
  const cls = `${base} ${className}`.trim();

  if (/^https?:\/\//i.test(href)) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId}
        className={cls}
        {...rest}
      >
        {children}
      </a>
    );
  }

  if (href.includes('#')) {
    return (
      <a href={href} data-testid={testId} className={cls} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} data-testid={testId} className={cls} {...rest}>
      {children}
    </Link>
  );
}
